/* eslint-disable no-lone-blocks */
// NPM imports
import React, { Fragment, useState } from "react";
import { Toastr, Button, NumberInput, Input } from "@revvsales/components";

// Internal Imports
import { GRID } from "../../constants";

// Components Imports
import { ReactSelect } from "../../commonComponents";

// Destructuring
const { CELL_TYPES } = GRID;

export default function AddGridColumn(props) {
  // Const Declarations

  // Local State Declarations

  const INITIAL_STATE = {
    characterLimit: "",
    description: "",
    editable: true,
    name: "",
    pickListDefault: {},
    pickListOptions: [],
    picklist: "",
    required: true,
    type: {},
  };

  const [state, setState] = useState(INITIAL_STATE);

  function _createAlias(text) {
    return text
      .trim()
      .toLowerCase()
      .split(" ")
      .join("_");
  }

  function _onChange(value, field) {
    const stateClone = { ...state };
    stateClone[field] = value;
    setState(stateClone);
  }

  // function _onCheckChange(event, field) {
  //   const stateClone = { ...state };
  //   stateClone[field] = JSON.parse(event.target.value);
  //   setState(stateClone);
  // }

  function _onSelectChange(field, value) {
    const stateClone = { ...state };
    stateClone[field] = value;
    setState(stateClone);
  }

  function _onPickListChange(e) {
    const stateClone = { ...state };
    stateClone.picklist = e.target.value;
    const picklistArray = stateClone.picklist.split(",");
    stateClone.pickListOptions = picklistArray;
    setState(stateClone);
  }

  function _displayError() {
    return Toastr.showToastr({
      type: "warning",
      message: "Please fill in the required fields.",
      timeout: 2000,
    });
  }

  function _onSubmit(e) {
    e.preventDefault();
    if (
      state.name !== "" &&
      state.description !== "" &&
      Object.keys(state.type).length > 0
    ) {
      if (
        state.type.label === "Single Line Field" &&
        state.characterLimit !== ""
      ) {
        const payload = {
          field: {
            name: _createAlias(state.name),
            type: "SingleLineField",
            props: {
              length: state.characterLimit,
            },
          },
          editable: true,
          label: state.name,
          name: _createAlias(state.name),
          type: "DirectColumn",
        };
        props.addColumn(payload);
      } else if (
        state.type.label === "Single Select Field" &&
        state.pickListOptions.length > 0
      ) {
        const payload = {
          field: {
            name: _createAlias(state.name),
            type: "SingleSelectField",
            props: {
              values: state.pickListOptions,
            },
          },
          editable: true,
          label: state.name,
          name: _createAlias(state.name),
          type: "DirectColumn",
        };
        props.addColumn(payload);
      } else {
        _displayError();
      }
    } else {
      _displayError();
    }
  }

  return (
    <div className="addgridcolumn-wrapper">
      <div className="popupform-title">Add custom column</div>
      <form onSubmit={_onSubmit} className="popupform-form">
        {/* Column Name */}
        <div className="popupform-div-wrapper">
          <span className="popupform-label">
            Column name<span className="required-input">*</span>
          </span>
          <Input
            autoFocus
            placeholder="Enter Column Name"
            value={state.name}
            onChange={e => _onChange(e.target.value, "name")}
            data-test="addgridcolumn-name-input"
          />
        </div>
        {/* Column Description */}
        <div className="popupform-div-wrapper">
          <span className="popupform-label">
            Column description<span className="required-input">*</span>
          </span>
          <Input
            placeholder="Enter Column Description"
            value={state.description}
            onChange={e => _onChange(e.target.value, "description")}
            data-test="addgridcolumn-desc-input"
          />
        </div>
        {/* Column Type */}
        <div className="popupform-div-wrapper">
          <span className="popupform-label">
            Column type<span className="required-input">*</span>
          </span>
          <ReactSelect
            isSearchable
            valueKey="type"
            onChange={value => _onSelectChange("type", value)}
            options={CELL_TYPES}
            value={state.type}
            data-test="addgridcolumn-type-select"
          />
        </div>
        {/* ****** If Free text ****** */}
        {state.type.label === "Single Line Field" && (
          <Fragment>
            {/* Free text character limit */}
            <div className="popupform-div-wrapper">
              <span className="popupform-label">
                Character limit<span className="required-input">*</span>
              </span>
              <NumberInput
                placeholder="Enter Character limit"
                value={state.characterLimit}
                onChange={value => _onChange(value, "characterLimit")}
                data-test="addgridcolumn-number-input"
              />
            </div>
          </Fragment>
        )}
        {/* ****** If PickList / MultiSelect ****** */}
        {state.type.label === "Single Select Field" && (
          <Fragment>
            {/* PickList Values */}
            <div className="popupform-div-wrapper">
              <span className="popupform-label">
                Picklist Value (add values seperated by comma)
                <span className="required-input">*</span>
              </span>
              <Input
                placeholder="Enter Picklist Values. Use comma to add more"
                value={state.picklist}
                onChange={_onPickListChange}
                data-test="addgridcolumn-list-input"
              />
            </div>
          </Fragment>
        )}
        <div className="popupform-footer">
          <div className="popupform-footer-actions">
            <Button
              type="submit"
              className="btn-md"
              onClick={_onSubmit}
              data-test="addgridcolumn-add-btn">
              Add
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

{
  /* Mandatory Column */
}
{
  /* <div className="addgridcolumn-div-wrapper">
          <div onChange={event => _onCheckChange(event, "required")}>
            <Label htmlFor="addgridcolumn-required-yes">
              <Input
                id="addgridcolumn-required-yes"
                checked={state.required}
                name="required"
                readOnly
                type="radio"
                value="true"
              />
              <span className="addgridcolumn-checkbox-value">Yes</span>
            </Label>
            <Label htmlFor="addgridcolumn-required-no">
              <Input
                id="addgridcolumn-required-no"
                checked={!state.required}
                name="required"
                readOnly
                type="radio"
                value="false"
              />
              <span className="addgridcolumn-checkbox-value">No</span>
            </Label>
          </div>
        </div> */
}
{
  /* Can Rep Edit */
}
{
  /* <div className="addgridcolumn-div-wrapper">
          <div onChange={event => _onCheckChange(event, "editable")}>
            <Label htmlFor="addgridcolumn-editable-yes">
              <Input
                id="addgridcolumn-editable-yes"
                checked={state.editable}
                name="editable"
                readOnly
                type="radio"
                value="true"
              />
              <span className="addgridcolumn-checkbox-value">Yes</span>
            </Label>
            <Label htmlFor="addgridcolumn-editable-no">
              <Input
                id="addgridcolumn-editable-no"
                checked={!state.editable}
                name="editable"
                readOnly
                type="radio"
                value="false"
              />
              <span className="addgridcolumn-checkbox-value">No</span>
            </Label>
          </div>
        </div> */
}

{
  /* Default PickList Value */
}
{
  /* <div className="popupform-div-wrapper">
  <span className="popupform-label">DEFAULT VALUE</span>
  <ReactSelect
    isSearchable
    valueKey="type"
    onChange={value => _onSelectChange("pickListDefault", value)}
    options={state.pickListOptions}
    value={state.pickListDefault}
  />
</div>; */
}



// WEBPACK FOOTER //
// ./src/components/AddGridColumn/index.js